import React from 'react';

export const usableIcons = [
    {label: "brush", icon: "dripicons-brush"},
    {label: "gear", icon: "dripicons-gear"},
    {label: "warning", icon: "dripicons-warning"},
    {label: "power", icon: "dripicons-power"},

    {label: "question", icon: "dripicons-question"},
    {label: "star", icon: "dripicons-star"},
    {label: "wallet", icon: "dripicons-wallet"},
    {label: "user", icon: "dripicons-user"},

    {label: "to-do", icon: "dripicons-to-do"},
    {label: "tags", icon: "dripicons-tags"},
    {label: "phone", icon: "dripicons-phone"},
    {label: "document", icon: "dripicons-document"},

    {label: "clock", icon: "dripicons-clock"},
    {label: "bell", icon: "dripicons-bell"},
    {label: "medical", icon: "dripicons-medical"},
    {label: "search", icon: "dripicons-search"},
]


export default function StringToIcon(props) {
    const iconValue = props.icon;
    const styleName = props.stylename


    // function useIcon(i){
    //     if (i != undefined) {
    //         return i.icon
    //     } else {
    //         return "dripicons-thumbs-down"
    //     }
    // }


    return (
        <i className={`${iconValue?.icon ?? ""} ${styleName}`} {...props} ></i>
    );
}